<template>
  <div v-if="item">
    <fields-list :item="item" :fields="fields" />
    <div class="save-panel">
      <svg class="svg-angle svg-angle-1" width="30" height="30" viewBox="0 0 29 29" xmlns="http://www.w3.org/2000/svg"><path d="M0 29V0C0 16.0163 12.9837 29 29 29H0Z"/></svg>
      <svg class="svg-angle svg-angle-2" width="30" height="30" viewBox="0 0 29 29" xmlns="http://www.w3.org/2000/svg"><path d="M0 29V0C0 16.0163 12.9837 29 29 29H0Z"/></svg>
      <button class="btn  btn-warning btn-icon" @click="updateItem">
        <span class="ti-save"></span>{{ 'save' | setText('Сохранить') }}
      </button>
    </div>
  </div>
</template>
<script>
import { cardUpdate, cardContent, pushLang } from "@/plugins/functions";

export default {
  data: () => ({
    cardLink: "tariffs",
    cardSetLink: "tariffs",
    item: null,
    fields: [
      {
        key: "title",
        label: "Название",
        isMultiLang: true,
        type: 'field',
      },
      {
        key: "description",
        label: "Краткое описание",
        isMultiLang: true,
        type: 'textarea',
      },
      {
        key: "price",
        label: "Стоимость",
        type: "field",
        textType: "number",
      },
      {
        key: "period",
        label: "Период (месяцев)",
        type: "field",
        textType: "number",
      },
      // {
      //   key: "client_count",
      //   label: "Количество детей",
      //   type: "field",
      //   textType: "number",
      // },
      {
        key: "is_active",
        label: "Период (месяцев)",
        type: "checkbox",
        textType: "number",
      },

    ],
  }),
  props: ["id"],
  async created() {
    this.item = await this.cardContent(this.cardLink, this.id);
  },
  methods: {
    cardUpdate: cardUpdate,
    cardContent: cardContent,
    pushLang: pushLang,
    async updateItem() {
      let item = await this.cardUpdate(this.cardSetLink, this.item, this.fields);
      // if (item){
      //   this.item = item;
      // }
    },
  },
};
</script>
<style>

</style>
